// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"7":"ac1ed3a7","273":"ac1ed3a7","295":"4e3231b8"}[chunkId] + ".chunk.css";
};